import { InstrumentOrderbook } from "../NLegs/Orderbook/Orderbook";
import { getKaminOrderBooks, KaminLeg } from "../../Requests/kamin2leg";
import { StepOrderSide } from "../../Interfaces/stepInterfaces";

export default function KaminOrderBooks({ legs }: { legs: KaminLeg[] }) {
  return <div className="kamin-orderbooks">
    <InstrumentOrderbook legCount={2} getBooks={getKaminOrderBooks} items={legs.map(leg => ({
      instrumentId: leg.instrumentId, ratio: leg.ratio, orderSide: leg.side as StepOrderSide,
    }))} />
  </div>;
}
